import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

export const StaffTenureStatusSchema = z.enum(['ACTIVE', 'FORMER']);
export type StaffTenureStatus = z.infer<typeof StaffTenureStatusSchema>;

const GetTenureDistributionRequestDtoSchema = z.object({
  status: StaffTenureStatusSchema.optional(),
  facilitiesIds: z.array(z.number()).optional(),
});

const TenureRangeBucketDtoSchema = z.object({
  range: z.string(),
  minMonths: z.number(),
  maxMonths: z.number().nullable(),
  count: z.number(),
});

const TenureDistributionResponseDtoSchema = z.object({
  status: StaffTenureStatusSchema,
  totalStaff: z.number(),
  distribution: z.array(TenureRangeBucketDtoSchema),
});

export type GetTenureDistributionRequestDto = z.infer<
  typeof GetTenureDistributionRequestDtoSchema
>;
export type TenureRangeBucketDto = z.infer<typeof TenureRangeBucketDtoSchema>;
export type TenureDistributionResponseDto = z.infer<
  typeof TenureDistributionResponseDtoSchema
>;

export const getTenureDistribution = (
  params: GetTenureDistributionRequestDto,
  config?: AxiosRequestConfig<GetTenureDistributionRequestDto>
) => {
  const data = GetTenureDistributionRequestDtoSchema.parse(params);
  return api
    .get('/staff/tenure-distribution', {
      params: data,
      ...config,
    })
    .then(responseContract(TenureDistributionResponseDtoSchema));
};
